<div class="search-controls-container ms-auto d-flex">

  <div class="search-box">
    <input type="text" [ngModel]="null" (ngModelChange)="term.next($event)" class="form-control form-control-solid" placeholder="Search here...">
  </div>
  <div class="search-control date-range-control" [(nzPopoverVisible)]="showDatePopup" nzPopoverOverlayClassName="qr-pop" [nzPopoverPlacement]="'bottom'" (nzPopoverVisibleChange)="datePopupStateChange($event)" [nzPopoverBackdrop]="true" nz-popover [nzPopoverContent]="popover" nzPopoverTrigger="click">
    <span *ngIf="!dateRange || !dateRange.length">{{dateLabel}}</span> <span *ngIf="dateRange && dateRange.length">{{dateRange[0] | date:'mediumDate'}} - {{dateRange[1] | date:'mediumDate'}}</span> <i class="fi fi-br-calendar"></i>
  </div>
  <div class="search-control filter-control" *ngIf="type === 'donations'" nzPopoverOverlayClassName="qr-pop" [nzPopoverPlacement]="'bottom'" [nzPopoverBackdrop]="true" nz-popover [nzPopoverContent]="filterPopover" nzPopoverTrigger="click">Filters <i class="fi fi-br-settings-sliders"></i></div>

</div>

<ng-template #popover class="p-0">

  <div>
    <bs-daterangepicker-inline (bsValueChange)="updateDate($event)" [maxDate]="today" [bsValue]="dateRange"></bs-daterangepicker-inline>

    <div class="text-right">
      <button class="btn btn-xs btn-outline-theme me-2" (click)="resetDate()">Reset</button>
      <button class="btn btn-xs btn-theme-secondary" (click)="showDatePopup = false">Apply</button>
    </div>
  </div>

</ng-template>

<ng-template #filterPopover class="p-0">

  <div class="field-container">

    <div class="form-group">
      <label class="mb-2">Filter by Status:</label>
      <nz-select
        class="form-control form-control-solid form-control-sm"
        nzPlaceHolder="All Statuses"
        [nzAllowClear]="true"
        [ngModel]="null"
        (ngModelChange)="updateField('status','=', $event)"
      >
        <nz-option nzValue="draft" nzLabel="Incomplete"></nz-option>
        <nz-option nzValue="active" nzLabel="Active"></nz-option>
        <nz-option nzValue="complete" nzLabel="Complete"></nz-option>
        <nz-option nzValue="cancelled" nzLabel="Cancelled"></nz-option>
        <nz-option nzValue="refunded" nzLabel="Refunded"></nz-option>
      </nz-select>
    </div>

    <div class="form-group mt-4">
      <label class="mb-2">Filter by Type</label>
      <nz-select
        class="form-control form-control-solid form-control-sm"
        [nzAllowClear]="true"
        nzPlaceHolder="One Off & Monthly"
        [ngModel]="null"
        (ngModelChange)="updateField('donation_type','=', $event)"
      >
        <nz-option nzValue="monthly" nzLabel="Monthly"></nz-option>
        <nz-option nzValue="single" nzLabel="One Off"></nz-option>
      </nz-select>
    </div>

  </div>

</ng-template>
